import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { GeneralServiceProxy, CreateQuestionCommand, QuestionServiceProxy,
  CreateOrEditQuestionDto, CreateOrEditQuestionDocumentDto } from '@src/app/service-proxies';
import { AppConsts } from '@src/app/shared/AppConsts';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Editor } from 'primeng/editor';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '@src/app/shared/utils/notification.service';
import { AuthService } from '../shared/auth.service';
import { Role } from '../shared/Roles';
import { DomSanitizer } from '@angular/platform-browser';
import { AudioRecordingServiceService } from '../mantee/question/audio-recording-service.service';

@Component({
  selector: 'app-guest-question',
  templateUrl: './guest-question.component.html',
  styleUrls: ['./guest-question.component.css']
})
export class GuestQuestionComponent implements OnInit, AfterViewInit,OnDestroy {

  saving = false;
  uploadUrl: string;

  @ViewChild('Editor', { static: false }) editor: Editor;

  quillObj: any;

  record: any;

  allDepartments: any;
  allCategories: any;
  allSubCategories: any;

  questionDocument: CreateOrEditQuestionDocumentDto = new CreateOrEditQuestionDocumentDto();

  departmentId: number;
  categoryId: number;
  subcategoryId: number;

  questionId: number;

  parentModel: CreateQuestionCommand = new CreateQuestionCommand();
  model: CreateOrEditQuestionDto = new CreateOrEditQuestionDto();

  content = '';
  constructor(private _generalService: GeneralServiceProxy,
    private http: HttpClient,
    private router: Router,
    private notify: NotificationService,
    private _activedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _questionService: QuestionServiceProxy,
    private audioRecordingService: AudioRecordingServiceService, private sanitizer: DomSanitizer) {
      this.audioRecordingService.recordingFailed().subscribe(() => {
        this.isRecording = false;
      });
  
      this.audioRecordingService.getRecordedTime().subscribe((time) => {
        this.recordedTime = time;
      });
  
      this.audioRecordingService.getRecordedBlob().subscribe((data) => {
        const fileToUpload = data.blob;
        const formData = new FormData();
        formData.append('file', fileToUpload, data.title);
        this.http.post(AppConsts.fileUploadUrl, formData)
        .subscribe(result => {
        const obj = JSON.parse(JSON.stringify(result));
        this.model.audioFileId = obj.id;
        this.model.audioFileDescription = JSON.stringify(result);
      });
        this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
        this.record=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
      });

     }

  ngOnInit() {
    this.uploadUrl = AppConsts.fileUploadUrl;
    this.model.questionDocuments = [];
    this.getAllDepartments();
    this._activedRoute.queryParams.subscribe(params => {
      this.questionId = params.questionId;
      this.getQuestion(this.questionId);
    });
  }

  ngAfterViewInit() {
    this.quillObj = this.editor.getQuill();
  }

  getQuestion(id: number) {
    if (id) {
      this._questionService.getQuestionDetailForEdit(id).subscribe(result => {
        this.model = result;
        this.getAllCategoriesByDepId();
        this.getAllSubCategoriesByCategoryId();
      });
    }
  }

  save() {
    if(this.isRecording)
    {
      this.notify.showError('Stop Recording');
       return;
    }    

    // if ((this.quillObj.getLength() - 1) < 50) {
    //   this.notify.showError('Please write more words.');
    //   return;
    // }
    debugger;
    this.saving = true;
    this.model.questionDetail = this.quillObj.getText();
    this.parentModel.createOrEditQuestionDto = this.model;
    if (this._authService.isLoggedIn && this._authService.userRole === Role.Mentee) {
      this._questionService.create(this.parentModel)
        .pipe(finalize(() => { this.saving = false; }))
        .subscribe(result => {
          this.router.navigate(['mentee/mentor-selection/', result],
           { queryParams: { 'department': this.model.departmentId, 'category': this.model.categoryId,
            'subCategory': this.model.subCategoryId } });
        });
    } else {
      
      this._authService.saveGuestQuestion(this.model);
      this.saving = false;
      console.log(this._authService.getsaveGuestQuestion());
      this.router.navigate(['/accounts/register/agree/mentee']);
      this.notify.showSuccess('PLease Logged in to complete the process');
    }
  }

  recordChange(event) {
    const fileToUpload = event.srcElement.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(AppConsts.fileUploadUrl, formData)
      .subscribe(result => {
        const obj = JSON.parse(JSON.stringify(result));
        this.model.audioFileId = obj.id;
        this.model.audioFileDescription = JSON.stringify(result);
      });
    const reader = new FileReader();
    reader.readAsDataURL(event.srcElement.files[0]);
    reader.onload = (_event) => {
      this.record = reader.result;
    };
  }


  VideoChange(event) {
    debugger;
    const fileToUpload = event.srcElement.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(AppConsts.fileUploadUrl, formData)
      .subscribe(result => {
        const obj = JSON.parse(JSON.stringify(result));
        this.questionDocument = new CreateOrEditQuestionDocumentDto();
        this.questionDocument.documentid = obj.id;
        this.questionDocument.documentDescription = JSON.stringify(result);
        this.model.questionDocuments.push(this.questionDocument);
        console.log(this.questionDocument);
        this.notify.showSuccess(`${obj.name} uploaded successfully`);
      });
  }





  myUploader(event) {
    for (let index = 0; index < event.files.length; index++) {
      const fileToUpload = event.files[index];
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      this.http.post(AppConsts.fileUploadUrl, formData).subscribe(result => {
        const obj = JSON.parse(JSON.stringify(result));
        this.questionDocument = new CreateOrEditQuestionDocumentDto();
        this.questionDocument.documentid = obj.id;
        this.questionDocument.documentDescription = JSON.stringify(result);
        this.model.questionDocuments.push(this.questionDocument);
        this.notify.showSuccess(`${obj.name} uploaded successfully`);
      });
    }
  }

  getAllDepartments() {
    this._generalService.getAllDepartments().subscribe(result => {
      this.allDepartments = result;
    });
  }

  getAllCategoriesByDepId() {
    if (this.model.departmentId) {
      this._generalService.getAllCategoriesByDepartmentId(this.model.departmentId)
        .subscribe(result => {
          this.allCategories = result;
        });
    } else {
      this.allCategories = [];
      this.allSubCategories = [];
    }
  }

  getAllSubCategoriesByCategoryId() {
    if (this.model.categoryId) {
      this._generalService.getAllSubCategoriesByCategoryId(this.model.categoryId)
        .subscribe(result => {
          this.allSubCategories = result;
        });
    } else {
      this.allSubCategories = [];
    }
  }

  ///Question Recode
  isRecording = false;
  recordedTime="00:00";
  blobUrl;
  recordData;
  AudioFile:any;



startRecording() {
  if (!this.isRecording) {
    this.isRecording = true;
    this.audioRecordingService.startRecording();
  }
}

abortRecording() {
  if (this.isRecording) {
    this.isRecording = false;
    this.audioRecordingService.abortRecording();
  }
}

stopRecording() {
  if (this.isRecording) {
    this.audioRecordingService.stopRecording();
    this.isRecording = false;
  }
}

clearRecordedData() {
  this.blobUrl = null;
  this.record=null;
}

ngOnDestroy(): void {
  this.abortRecording();
}

}
